import { render, staticRenderFns } from "./AsterMail.vue?vue&type=template&id=5c5aeeb2&"
import script from "./AsterMail.vue?vue&type=script&lang=js&"
export * from "./AsterMail.vue?vue&type=script&lang=js&"
import style0 from "./AsterMail.vue?vue&type=style&index=0&id=5c5aeeb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports